<template>
  <div class="switch-font-box">
    <img class="nav-icon" v-if="theme==='dark'" src="@/assets/icon-font-size.svg" alt="" @click="showSwitchFont" />
    <img class="nav-icon" v-if="theme==='light'" src="@/assets/icon-font-size-white.svg" alt="" @click="showSwitchFont" />
    <div class="size-list" :class="showFontStatus">
      <span :class="currentSize === 'small' ? 'green-color' : ''" @click="confirmSize('small')"
        >小</span
      >
      <span :class="currentSize === 'medium' ? 'green-color' : ''" @click="confirmSize('medium')"
        >中</span
      >
      <span :class="currentSize === 'big' ? 'green-color' : ''" @click="confirmSize('big')"
        >大</span
      >
    </div>
  </div>
</template>
<script>
import { getBrandImageUrl } from "@/js/brandImages"

export default {
  data() {
    return {
      showFontStatus: "fold",
      currentSize: localStorage.getItem("size") ? localStorage.getItem("size") : "big",
    }
  },
  props:{
    theme:'dark'
  },
  mounted() {
    this.initFontSize()
  },
  methods: {
    getBrandImageUrl,

    initFontSize() {
      const size = localStorage.getItem("size") ? localStorage.getItem("size") : "big"
      if (size) {
        this.currentSize = size
        this.confirmSize(size)
      }
    },

    showSwitchFont() {
      this.currentSize = localStorage.getItem("size") ? localStorage.getItem("size") : "big"
      if (this.showFontStatus === "fold") {
        this.showFontStatus = "expand"
      } else {
        this.showFontStatus = "fold"
      }
    },

    confirmSize(size) {
      this.currentSize = size
      localStorage.setItem("size", size)
      this.showFontStatus = "fold"
      let fontSize
      switch (size) {
        case "small":
          fontSize = 1.1
          break
        case "medium":
          fontSize = 1.4
          break
        case "big":
          fontSize = 1.8
          break
      }
      document.body.style.setProperty("--switch-font-size", fontSize + "rem")
      //这句是关键，否则无法动态更改标签上已有font-size的字体大小，以及无法自适应更改高度，宽度
      var root = document.querySelector(":root")
      root.style.setProperty("--switch-font-size", fontSize + "vw")
    },
  },
}
</script>
<style scoped lang="less">
.nav-icon {
  width: 1.7rem !important;
}
.switch-font-box {
  position: relative;
  margin-right: 0.5rem;
  display: inline-flex;
  .size-list {
    position: absolute;
    background: #fff;
    width: 3rem;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    height: 0;
    transition: height linear 0.1s;
    border-radius: 0.4rem;
    font-size: 1rem;
    font-weight: 400;
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    text-align: center;
    &.expand {
      height: 8rem !important;
      border: 1px solid #eee;
      transition: height linear 0.1s;
    }
    span {
      padding: 0.5rem 0;
      display: inline-block;
      box-sizing: border-box;
      line-height: 1.5;
      color: #333;
    }
  }
}
.green-color {
  color: #0dcb8b !important;
}
</style>
<style lang="less">
.switch-font-size {
  font-size: var(--switch-font-size) !important;
  font-weight: 600;
  line-height: 1.3;
}
</style>
